module.exports = __webpack_public_path__ + "img/icon01.1682684f.png";